// Datos de ejemplo para ciudades y barrios de Paraguay.
// Esta lista puede y debería ampliarse con el catálogo real utilizado por el negocio.

// Arreglo de ciudades disponibles para selección
export const CIUDADES: string[] = [
  // Capital
  'Asunción',
  // Departamento Central
  'San Lorenzo',
  'Luque',
  // Itapúa
  'Encarnación',
  // Alto Paraná
  'Ciudad del Este',
];

// Mapa ciudad -> lista de barrios sugeridos
export const BARRIOS_POR_CIUDAD: Record<string, string[]> = {
  // Barrios de Asunción (ejemplos)
  'Asunción': ['Recoleta', 'Villa Morra', 'San Vicente', 'Tacumbú', 'Las Mercedes'],
  // Barrios de San Lorenzo (ejemplos)
  'San Lorenzo': ['San Miguel', 'Barcequillo', 'Capilla del Monte', 'Mariscal Estigarribia'],
  // Barrios de Luque (ejemplos)
  'Luque': ['Itapuamí', 'Mora Cué', 'Tarumandy', 'Cañada Garay'],
  // Barrios de Encarnación (ejemplos)
  'Encarnación': ['Centro', 'Pacú Cuá', 'San Isidro', 'Chaipé'],
  // Barrios de Ciudad del Este (ejemplos)
  'Ciudad del Este': ['Ciudad Nueva', 'Boquerón', 'Pablo Rojas', 'Don Bosco'],
};
